

const URLs = {
  AUTH_USER_SIGN_IN: "Account/Login",
  AUTH_USER_GET_USER_INFO: "user/userinfo",
  AUTH_TOKEN_GET_BY_REFRESH_TOKEN: "login/refreshToken",

  USER_REG_NEW: "Account/code",
  USER_REG_VERIFY_PHONE: "Account/validate",
  USER_RESET_PASS_VERIFY_PHONE: "user/verifyUserName",
  USER_RESET_PASS_VERIFY_PHONE_CHECK_CODE: "user/verifyUserCode",
  USER_RESET_PASS: "user/ResetUserPassword",

  PAGE_VERIFY_PHONE_NUMBER: "/verify",
  PROFILE_LOAD_USER_DATA: "user/userinfo",
  PROFILE_EDIT_USER_DATA: "user/userinfo",
  PROFILE_EDIT_USER_PASSWORD: "user/ChangeUserPassword",

  DASHBOARD_GET_DATA: "Account/summaryReport",

  KALA_KHADAMAT_NEW: "Kala/Upsert",
  KALA_KHADAMAT_GET_ALL: "Kala/List",
  KALA_KHADAMAT_GET_BY_ID: "Kala/",
  KALA_KHADAMAT_DELETE: "Kala/",
  KALA_SHENASEH_GET:"Kala/GetKalaShenaseh",
  KALA_KHADAMAT_UPSERT_EXCEL:"Kala/UpsertByExcel",

  SHERKAT_NEW: "ShakhsSherkat/Upsert",
  SHERKAT_GET_ALL: "ShakhsSherkat/List",
  SHERKAT_GET_ALLSMALL: "ShakhsSherkat/AllList",
  SHERKAT_GET_BY_ID: "ShakhsSherkat/",
  SHERKAT_DELETE: "ShakhsSherkat/",

  TARAF_HESAB_NEW: "TarafHesab/Upsert",
  TARAF_HESAB_GET_ALL: "TarafHesab/List",
  TARAF_HESAB_GET_BY_ID: "TarafHesab/",
  TARAF_HESAB_DELETE: "TarafHesab/",
  TARAF_HESAB_UPSERT_EXCEL : "TarafHesab/UpsertByExcel?",

  SORATHESAB_HESAB_NEW: "SoratHesab/Upsert",
  SORATHESAB_GET_ALL: "SoratHesab/List",
  SORATHESAB_HESAB_GET_BY_ID: "SoratHesab/",
  SORATHESAB_DELETE: "SoratHesab/",
  SORATHESAB_GET_TAX_ID: "Tax/GetTaxId",
  SORATHESAB_REPORT_ID: "SoratHesab/report/excel/{id}",
  SORATHESAB_REPORT_PDF_ID: "SoratHesab/report/pdf/{id}",
  SORATHESAB_GET_SERIAL: "SoratHesab/serial/{id}",
  SORATHESAB_GET_HISTORY: "SoratHesab/History?soratHesab={id}", 
  SORATHESAB_UPSERT_BY_EXCEL: "SoratHesab/UpsertByExcel",
  SORATHESAB_UPSERT_BY_JSON: "SoratHesab/UpsertByJson",
  


  TAX_INQUERY_BY_REF_ID: "Tax/InquiryByReference",
  TAX_SEND_INVOICE: "Tax/SendInvoice",
  TAX_SEND_INVOICES: "Tax/SendInvoices",
  TAX_GET_STATUES_INVOICE: "Tax/GetInvoiceStatus?invoiceId={sId}",
  TAX_REVOKE_INVOICE: "Tax/RevokeInvoice",
  TAX_CORRECT_INVOICE: "Tax/EslahInvoice",
  TAX_RETURN_INVOICE: "Tax/ReturnInvoice",
  TAX_ESTELAM_INVOICE: "Tax/InquiryBySoratHesabId",

  SETTING_GET_ALL: "Setting/List",
  SETTING_GET_BY_ID: "Setting/",
  SETTING_EDIT: "Setting/Upsert",
  SETTING_DEFAULT: "Setting/GetDefault",
  SETTING_ALL_DEFAULT: "Setting/GetDefaultWithList",
  SETTING_GET_ALL_SHERKAT: "Setting/GetAllSherkatSettingList",
};

export default URLs;
